/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdLocationOk
 */
export interface GetCharactersCharacterIdLocationOk {
    /**
     * solar_system_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdLocationOk
     */
    solarSystemId: number;
    /**
     * station_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdLocationOk
     */
    stationId?: number;
    /**
     * structure_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdLocationOk
     */
    structureId?: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdLocationOk interface.
 */
export function instanceOfGetCharactersCharacterIdLocationOk(value: object): value is GetCharactersCharacterIdLocationOk {
    if (!('solarSystemId' in value) || value['solarSystemId'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdLocationOkFromJSON(json: any): GetCharactersCharacterIdLocationOk {
    return GetCharactersCharacterIdLocationOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdLocationOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdLocationOk {
    if (json == null) {
        return json;
    }
    return {
        
        'solarSystemId': json['solar_system_id'],
        'stationId': json['station_id'] == null ? undefined : json['station_id'],
        'structureId': json['structure_id'] == null ? undefined : json['structure_id'],
    };
}

export function GetCharactersCharacterIdLocationOkToJSON(json: any): GetCharactersCharacterIdLocationOk {
    return GetCharactersCharacterIdLocationOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdLocationOkToJSONTyped(value?: GetCharactersCharacterIdLocationOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'solar_system_id': value['solarSystemId'],
        'station_id': value['stationId'],
        'structure_id': value['structureId'],
    };
}

